import ScenarioSelectionRedefinedWrapperTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate';
import Content
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate/Content';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';

const ScenarioSelectionRedefinedTaxStrategyStepTemplate = ({
  resource,
}) => {
  return (
    <ScenarioSelectionRedefinedWrapperTemplate
      resource={resource}
      layout={Content}
    />
  );
};

ScenarioSelectionRedefinedTaxStrategyStepTemplate.defaultProps = {
};

ScenarioSelectionRedefinedTaxStrategyStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ScenarioSelectionRedefinedTaxStrategyStepTemplate;
